import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* getOrderHistory(action) {
  const {
    data: {
      filterObj,
      page,
      pageSize,
      orderBy,
      orderType,
      locationVisibility,
      materialVisibility,
      accessToken,
    },
  } = action.payload

  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/order-history/get-history`,
        {
          filterObj,
          page,
          pageSize,
          orderBy,
          orderType,
          locationVisibility,
          materialVisibility,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
    )
    yield put(actions.getOrderHistory.success(response.data, page, pageSize))
  } catch (error) {
    yield put(actions.getOrderHistory.failure())
  }
}

export default function* watchOrderHistory() {
  yield all([takeEvery(actions.GET_ORDER_HISTORY.REQUEST, getOrderHistory)])
}

export { getOrderHistory }
